const badgeConfig = {
  // Generic
  active: { class: 'badge-success', label: 'Aktif' },
  inactive: { class: 'badge-danger', label: 'Nonaktif' },
  draft: { class: 'badge-gray', label: 'Draft' },
  pending: { class: 'badge-warning', label: 'Menunggu' },
  approved: { class: 'badge-primary', label: 'Disetujui' },
  rejected: { class: 'badge-danger', label: 'Ditolak' },
  completed: { class: 'badge-success', label: 'Selesai' },
  cancelled: { class: 'badge-danger', label: 'Dibatalkan' },
  posted: { class: 'badge-success', label: 'Diposting' },
  
  // PO / PR
  pending_approval: { class: 'badge-warning', label: 'Menunggu Persetujuan' },
  sent: { class: 'badge-info', label: 'Dikirim' },
  partial: { class: 'badge-warning', label: 'Sebagian' },
  received: { class: 'badge-success', label: 'Diterima' },
  ordered: { class: 'badge-info', label: 'Diproses' },
  
  // Invoice / Payment
  unpaid: { class: 'badge-warning', label: 'Belum Dibayar' },
  paid: { class: 'badge-success', label: 'Lunas' },
  overdue: { class: 'badge-danger', label: 'Jatuh Tempo' },
  
  // Stock
  in: { class: 'badge-success', label: 'Masuk' },
  out: { class: 'badge-danger', label: 'Keluar' },
  adjustment: { class: 'badge-info', label: 'Penyesuaian' },
  transfer_in: { class: 'badge-info', label: 'Transfer Masuk' },
  transfer_out: { class: 'badge-warning', label: 'Transfer Keluar' },
  
  // Stock alerts
  safe: { class: 'badge-success', label: 'Stok Aman' },
  low: { class: 'badge-warning', label: 'Stok Menipis' },
  out_of_stock: { class: 'badge-danger', label: 'Stok Habis' },
  
  // Credit
  credit: { class: 'badge-warning', label: 'Kredit' },
  cash: { class: 'badge-success', label: 'Tunai' },
  transfer: { class: 'badge-info', label: 'Transfer' },
};

export default function StatusBadge({ status, customLabel, dot = false, className = '' }) {
  const config = badgeConfig[status];
  if (!config && !customLabel) return null;

  const badgeClass = config?.class || 'badge-gray';
  const label = customLabel || config?.label || status;

  return (
    <span className={`${badgeClass} ${dot ? 'pl-2' : ''} ${className}`}>
      {dot && (
        <span className={`w-1.5 h-1.5 rounded-full inline-block mr-1.5 ${
          badgeClass.includes('success') ? 'bg-success-500' :
          badgeClass.includes('warning') ? 'bg-warning-500' :
          badgeClass.includes('danger') ? 'bg-danger-500' :
          badgeClass.includes('info') ? 'bg-info-500' :
          'bg-surface-400'
        }`} />
      )}
      {label}
    </span>
  );
}

export { badgeConfig, badgeConfig as statusBadgeMap, badgeConfig as statusLabelMap };